import React, { useEffect, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import Btn from '../../atoms/btn';
import { IconComponent } from '../../atoms/icons/iconComponent';
import DsList from '../../atoms/list';

const DropdownList = (props) => {
  const {
    className,
    items,
    initialId,
    label,
    placeholder, // Este es el placeholder para el botón principal
    onChange,
    lang,
    withSearch,
    variant,
    noTitle,
    searchPlaceholder, // Nuevo prop para el placeholder del input de búsqueda
  } = props;

  const idKey = props.idKey || 'code';

  const textKey = props.textKey || 'name';
  const searchText = props.searchText ? props.searchText : 'searchText';
  const initialValue = initialId ? items.find((item) => item[idKey] === initialId[idKey]) : items[0];
  const [activeItem, setActiveItem] = useState(initialValue);
  const [itemsList, setItemsList] = useState(items);
  const [isVisible, setVisible] = useState(false);
  const [isLeft, setPositionLeft] = useState(false);

  const container = useRef();
  const inputRef = useRef();

  const selectedActive = (item) => {
    setActiveItem(item);
    onChange(item);
  };

  const onClickItem = (item) => {
    selectedActive(item);
    setVisible(false);
  };

  const toggleVisible = (ev) => {
    ev.preventDefault();
    const toggleVisibleDebounce = debounce(() => setVisible(!isVisible), 300);
    toggleVisibleDebounce();
  };

  useEffect(() => {
    if (isVisible && withSearch) {
      inputRef.current.focus();
    }
  }, [isVisible]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (container.current && !container.current.contains(event.target)) {
        setVisible(false);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [container]);

  useEffect(() => {
    if (container.current) {
      const { left, right } = container.current.getBoundingClientRect();
      if (left > right) {
        setPositionLeft(true);
      } else {
        setPositionLeft(false);
      }
    }
    setActiveItem(initialValue);
  }, [label, lang]);

  useEffect(() => {
    if (searchText !== 'searchText' && (/[^\\D]/).test(searchText)) {
      selectItem(searchText);
    }
  }, [searchText]);

  useEffect(() => {
    setItemsList(items);
  }, [items]);

  const selectItem = (inputValue) => {
    const filterItems = items.filter((el) => {
      const idKeyHasInput = el[idKey]
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      const textKeyHasInput = el[textKey]
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      return idKeyHasInput || textKeyHasInput;
    });
    setItemsList(filterItems);
    if (filterItems.length > 0) {
      selectedActive(filterItems[0]);
    }
  };

  const onChangeInput = (ev) => {
    const inputValue = ev.target.value;
    if (inputValue === '') {
      setItemsList(items);
    }
    if (inputValue) {
      selectItem(inputValue);
    }
  };
  const showTitle = !noTitle && label;

  return (
          <div className={`${className || ''} relative`} ref={container}>
            <div className="flex items-center">
              {showTitle && <div className="capitalize whitespace-nowrap w-1/2 md:w-auto text-gray-900">
                {label}:
              </div>}
              <Btn
                      onClick={(ev) => toggleVisible(ev)}
                      onFocus={(ev) => toggleVisible(ev)}
                      className="flex-grow-default ml-1 min-w-12"
                      iconAfter="arrow"
                      itemClass="justify-between"
              >
                {/* Mostrar placeholder si no hay item activo, sino mostrar el item */}
                {activeItem && activeItem[textKey] ? activeItem[textKey] : (
                  <span className="text-gray-400">{placeholder}</span>
                )}
              </Btn>
            </div>
            <div
                    className={`absolute top-0  bg-white z-10 shadow-lg min-w-full max-h-xxs overflow-auto
        ${isLeft ? 'left-0' : 'right-0'}
        ${isVisible ? '' : 'hidden'}`}
            >
              <header className="bg-gray-100 text-xs px-3 py-1 flex">
                {withSearch && (
                        <input
                                className="w-full bg-transparent focus:bg-white focus:outline-none text-gray-400"
                                ref={inputRef}
                                placeholder={searchPlaceholder || placeholder} // Usar searchPlaceholder si existe
                                onChange={onChangeInput}
                        />
                )}
                <Btn
                        onClick={(ev) => toggleVisible(ev)}
                        className="w-full font-extrabold  text-gray-900  whitespace-nowrap capitalize"
                        onFocus={(ev) => toggleVisible(ev)}
                >
                  {label}

                  <IconComponent icon="cross" className="ml-auto md:hidden"/>
                </Btn>
              </header>
              <DsList
                      variant={variant}
                      items={itemsList}
                      selectedItem={activeItem}
                      textKey={textKey}
                      className="px-3 py-1 text-black font-extrabold"
                      onChange={(ev, el) => onClickItem(ev, el)}
              />
            </div>
          </div>
  );
};

export default DropdownList;
